import React from 'react';
import { StyleSheet } from 'react-native';
import Svg, { Circle } from 'react-native-svg';
import { appColors } from '../../assets/styles/global';

const colors = {
  transparent: 'transparent',
  background: appColors.white,
  donutGreyRing: appColors.gray,
};

const DonutChart = ({ width, radius, percentage }) => {
  const perimeter = 2 * Math.PI * radius;
  const strokeDashOffset = perimeter - ((perimeter * percentage) / 100);
  return (
    <Svg viewBox="0 0 42 42" style={styles.svg} height={width} width={width}>
      <Circle cx="21" cy="21" r={radius} fill={colors.background} />
      <Circle cx="21" cy="21" r={radius} fill={colors.transparent} stroke={colors.donutGreyRing} strokeWidth={8} />
      <Circle
        cx="21"
        cy="21"
        r={radius}
        fill={colors.transparent}
        stroke={appColors.primary}
        strokeWidth={8}
        strokeDasharray={perimeter}
        strokeDashoffset={strokeDashOffset || 0}
      />
    </Svg>
  );
};

const styles = StyleSheet.create({
  svg: {
    overflow: 'visible',
    transform: [{ rotateZ: '-90deg' }],
  },
});

export default DonutChart;
